import { Button } from "antd";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface RenderClearFiltersButtonProps {
  onClick?: () => void;
  className?: string;
}

const RenderClearFiltersButton: FC<RenderClearFiltersButtonProps> = ({
  onClick,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center">
      <Button className={`-mt-2 mb-2 ${className}`} onClick={onClick}>
        {t("clear-filters.all")}
      </Button>
    </div>
  );
};

export { RenderClearFiltersButton };
